import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  modifiers: [],
  state: []
}

function IconGroup(props) {
  const { inverse, icons } = props
  return (
    <div
      className={resolveProps(props, config, 'IconGroup')}
    >
      {icons?.map((icon, index) => {
        if (index + 1 === icons.length) {
          return (
            <i
              key={index}
              className={`${icon.name} mdn-Icon--${icon.size}`}
              aria-label ={icon.ariaLabel}
            ></i>
          )
        }
        return (
          <React.Fragment key={index}>
            <i
              aria-label={icon.ariaLabel}
              className={`${icon.name} mdn-Icon--${icon.size}`}
            ></i>
            <span className="mdn-IconGroup-plus">+</span>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default IconGroup

IconGroup.propTypes = {
  inverse: PropTypes.bool,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      ariaLabel: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired
    }).isRequired
  )
}
